<template>

<div  class="container-fluid_" >

<div style="margin-top:100px;" class="modal" id="staticBackdrop" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog " role="document">
    <div class="modal-content">

      <div style="background-color:#FFCC00" class="modal-header border border-primary">
        <h4 class="modal-title" id="staticBackdropLabel">
          <i  class="fas fa-store mr-3" aria-hidden="true"></i>
          <strong><span style="color:#3366CC">SELEZIONARE UNA SEDE</span></strong></h4>
      </div>    
      <div class="modal-body ">

        <h5 ></h5>


  <div v-if="spinner">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </div>  
  <div v-else class="form-group">
  <!--<label for="store"><strong>Sede</strong></label>-->
    <select  required class="form-control" v-model="storeId">
      <option  v-for="(item,index) in items" :value="item.storeId" :key="index">{{item.store}}</option>        
    </select>
    <small style="color:red"  class="form-text "><strong>{{err_msg}}</strong> </small>       
  </div>

  
      </div>
      <div class="modal-footer border border-primary">
        <button @click="submit()" type="button" class="btn btn-primary">
          <i style="color:yellow" class="fas fa-check-circle mr-3" aria-hidden="true"></i>
          ACCEDI</button>        
      </div>
    </div>
  </div>
</div>




  
</div>

</template>
<script>


import api from '@/api'
import { mapGetters }  from 'vuex';
export default {
 data () {
    return {

      storeId : 0,
      err_msg : '',
      items   : [],
      stores  : [],
       msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      spinner     : false

    }
  },
  computed: {
    ...mapGetters(['company','userId']) 
  },
mounted()
{
  $('#staticBackdrop').modal('show')
  
},  
created()
{
  this.getData()
},
methods :{

async getData()
{
  
  let sp    = {'sp' : 'spStoresCompany'}
  let data  = {'companyId' : this.company.Id,'userId':this.userId}
  let json  = Object.assign(data, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {

              this.stores = res.data.recordsets[0]  
              this.items = res.data.recordsets[0]

              if(res.data.recordsets[1].length > 0)
              {
                
                this.items = res.data.recordsets[1]
              
              }
              
              

              if(res.data.recordsets[0].length==0)
              {   
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
               
                return
              }   
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
              this.spinner = false
        });


},
submit()
{
  if(this.storeId == 0)
  {
    this.err_msg = 'Selezionare una sede.'
    return
  }
  
  

  let store = this.items.filter(item => item.storeId == this.storeId)

  this.$store.commit('SET_COMPANY_STORES',this.stores) 
  this.$store.commit('AUTH_STORE_ID',this.storeId) 
  this.$store.commit('AUTH_STORE_NAME',store[0].store) 
  this.$store.commit('AUTH_STORE_CUST_GROUP',store[0].customerGroupId)
  
  $('#staticBackdrop').modal('hide')   
  this.$nextTick(()  => {           
    
      this.$emit('close')
  
    })    


},


}

}

</script>
<style scoped>
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}
</style>